import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Popover from '@material-ui/core/Popover';
import { makeStyles } from '@material-ui/core/styles';

import {
  MenuItem,
  styles,
  MenuList,
  Button,
  ButtonContent,
  ExpandIcon,
} from './OverrideMenu.styled';

const anchorOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
};

const useStyles = makeStyles(styles);

const OverrideMenu = ({ options, value, onChange, hasGradeOverride }) => {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef();
  const classes = useStyles();

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const handleChange = (selectedValue) => (event) => {
    handleClose();
    onChange(event, selectedValue);
  };

  const { hasLightText, name } =
    options.find((option) => option.value === value) || {};

  return (
    <>
      <Button
        onClick={handleOpen}
        ref={buttonRef}
        disableRipple
        data-testid="override-menu"
        hasLightText={hasLightText}
        disabled={!hasGradeOverride}
      >
        <ButtonContent>{name}</ButtonContent>
        {hasGradeOverride && (
          <ExpandIcon title="override-menu-open-close-icon" open={open} />
        )}
      </Button>
      <Popover
        anchorEl={buttonRef.current}
        anchorOrigin={anchorOrigin}
        getContentAnchorEl={null}
        open={open}
        onClose={handleClose}
        classes={{ paper: classes.paper }}
      >
        <MenuList autoFocus>
          {options.map(({ value: itemValue, name: itemName }) => (
            <MenuItem
              key={itemValue}
              selected={itemValue === value}
              onClick={handleChange(itemValue)}
              data-testid="override-menu-item"
            >
              {itemName}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </>
  );
};

OverrideMenu.propTypes = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      hasLightText: PropTypes.bool,
    })
  ).isRequired,
  onChange: PropTypes.func,
  hasGradeOverride: PropTypes.bool,
};

OverrideMenu.defaultProps = {
  value: undefined,
  onChange: () => {},
  hasGradeOverride: false,
};

export default OverrideMenu;
